// extracted by mini-css-extract-plugin
export var link = "arrow-link-module--link--2r1Q9";
export var arrow = "arrow-link-module--arrow--11nYs";